import {Club} from "../interface/club.interface";
import {Department} from "../interface/department.interface";

export let initClub: Club = {_id: "", createdAt: new Date(), kind: "", name: "", usage: 'Y', workplace: ""};
export let initDepartment: Department = {
    _id: "",
    departmentCode: "",
    departmentName: "",
    workplace: ""
};